import { confirmAlert } from '../components/AppAlert/appAlert';

let reportGenerationInProgress = false;
let activeAbortController: AbortController | null = null;

export function setReportGenerationInProgress(active: boolean): void {
  reportGenerationInProgress = Boolean(active);
}

export function isReportGenerationInProgress(): boolean {
  return reportGenerationInProgress;
}

/** Binds the in-flight generate request so it can be aborted if the user leaves. */
export function registerReportGenerationAbort(controller: AbortController): void {
  if (activeAbortController && activeAbortController !== controller) {
    activeAbortController.abort();
  }
  activeAbortController = controller;
}

export function clearReportGenerationAbort(controller: AbortController): void {
  if (activeAbortController === controller) {
    activeAbortController = null;
  }
}

/** Aborts the active generate HTTP request and clears the in-progress flag. */
export function cancelActiveReportGeneration(): void {
  if (activeAbortController) {
    activeAbortController.abort();
    activeAbortController = null;
  }
  reportGenerationInProgress = false;
}

/**
 * Warns while an AI report is generating. User can stay or leave; leaving aborts the request.
 * @returns true when navigation should proceed.
 */
export async function confirmAbandonReportGeneration(
  actionDescription = 'leave this page'
): Promise<boolean> {
  if (!reportGenerationInProgress) {
    return true;
  }

  const stay = await confirmAlert({
    type: 'warning',
    title: 'Report generation in progress',
    message: `AI report generation is still running. If you ${actionDescription}, the request will be cancelled immediately so our servers and AI services stop processing. You may need to generate the report again.\n\nStay on this page until it finishes, or leave and cancel generation.`,
    confirmText: 'Stay on page',
    cancelText: 'Leave anyway — cancel generation',
  });

  if (stay) {
    return false;
  }

  cancelActiveReportGeneration();
  return true;
}
